// src/components/Icons.tsx
// 라인 기반의 미니멀 SVG 아이콘 세트 (medical / clinical UI에 어울리는 톤)
// stroke="currentColor" 방식이라 부모 button의 color 속성을 그대로 따라간다.

import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
  strokeWidth?: number;
}

const base = (size: number = 24, strokeWidth: number = 2): React.SVGProps<SVGSVGElement> => ({
  width: size,
  height: size,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const
});

export const MicIcon: React.FC<IconProps> = ({ size, className, strokeWidth }) => (
  <svg {...base(size, strokeWidth)} className={className}>
    <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
    <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
    <line x1="12" y1="19" x2="12" y2="23" />
    <line x1="8" y1="23" x2="16" y2="23" />
  </svg>
);

export const StopIcon: React.FC<IconProps> = ({ size, className, strokeWidth }) => (
  <svg {...base(size, strokeWidth)} className={className}>
    <rect x="6" y="6" width="12" height="12" rx="2" />
  </svg>
);

export const ReconnectIcon: React.FC<IconProps> = ({ size, className, strokeWidth }) => (
  <svg {...base(size, strokeWidth)} className={className}>
    <polyline points="23 4 23 10 17 10" />
    <polyline points="1 20 1 14 7 14" />
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
  </svg>
);

export const StethoscopeIcon: React.FC<IconProps> = ({ size, className, strokeWidth }) => (
  <svg {...base(size, strokeWidth)} className={className}>
    <path d="M4.8 2.3A.3.3 0 1 0 5 2H4a2 2 0 0 0-2 2v5a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6V4a2 2 0 0 0-2-2h-1a.2.2 0 1 0 .3.3" />
    <path d="M8 15v1a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6v-4" />
    <circle cx="20" cy="10" r="2" />
  </svg>
);

export const HospitalIcon: React.FC<IconProps> = ({ size, className, strokeWidth }) => (
  <svg {...base(size, strokeWidth)} className={className}>
    <path d="M12 6v4" />
    <path d="M14 14h-4" />
    <path d="M14 18h-4" />
    <path d="M14 8h-4" />
    <path d="M18 12h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h2" />
    <path d="M18 22V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v18" />
  </svg>
);

export const UserIcon: React.FC<IconProps> = ({ size, className, strokeWidth }) => (
  <svg {...base(size, strokeWidth)} className={className}>
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

export const SearchIcon: React.FC<IconProps> = ({ size, className, strokeWidth }) => (
  <svg {...base(size, strokeWidth)} className={className}>
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

export const AlertIcon: React.FC<IconProps> = ({ size, className, strokeWidth }) => (
  <svg {...base(size, strokeWidth)} className={className}>
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="12" />
    <line x1="12" y1="16" x2="12.01" y2="16" />
  </svg>
);

export const ChevronLeftIcon: React.FC<IconProps> = ({ size, className, strokeWidth }) => (
  <svg {...base(size, strokeWidth)} className={className}>
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

export const ChevronRightIcon: React.FC<IconProps> = ({ size, className, strokeWidth }) => (
  <svg {...base(size, strokeWidth)} className={className}>
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

export const CloseIcon: React.FC<IconProps> = ({ size, className, strokeWidth }) => (
  <svg {...base(size, strokeWidth)} className={className}>
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);
